import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { ClipLoader } from "react-spinners";
import "./report.css"
import { FaCalendarAlt } from "react-icons/fa";
import ReportCard from './reportCard/reportCard';
import ApiService from '../../../services/apiService';

const ReportTotalOrder = ({ Currency }) => {
    const [selectedFilter, setSelectedFilter] = useState('4');
    const [data, setData] = useState([]);
    let navigate = useNavigate();

    useEffect(() => {
        getSumData()
    }, [selectedFilter]);

    const handleFilterChange = async (selectedFilter) => {
        setSelectedFilter(selectedFilter?.value);
        await getSumData();
    };
    const getSumData = async () => {
        try {
            const apiService = new ApiService();
            // let paramaters = `?GetBy=${selectedFilter}&PageNo=${1}&PageSize=${50}`;
            let res = await apiService.get("GET_ORDER_REPORTS");
            
            setData(res?.data?.result.reverse())
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const ThirdFilter = [
        { value: '0', label: 'Day' },
        { value: '1', label: 'Week' },
        { value: '2', label: 'Month' },
        { value: '3', label: 'Year' },
        { value: '4', label: 'All Time' },
    ];
    
    return (
        <div className='p-lg-5'>
            <div className='px-lg-5'>
                <div className='' >
                    <div className='d-flex mbl-center gap-3 end'>
                        <div className='d-flex'>
                            <nav className="nav nav-pills weekfilter ">
                                {ThirdFilter?.map((filter) => (
                                    <button
                                        key={filter.value}
                                        className={`nav-link ${selectedFilter === filter?.value ? 'activecls' : ''}`}
                                        onClick={() => handleFilterChange(filter)}
                                    >
                                        {filter?.label}
                                    </button>
                                ))}
                            </nav>
                        </div>
                        <div className='custom center gap-2'>Custom <FaCalendarAlt /></div>
                    </div>
                </div>
                <div className='row'>
                    {data?.map((data) => (
                        <div className='pt-5  col-4'>
                            <ReportCard data={data} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(ReportTotalOrder);